import { Trans } from "@lingui/react/macro"
import { Button, Center, Stack, Text, Title } from "@mantine/core"
import { Link } from "@tanstack/react-router"
import { Logo } from "../Logo"

/**
 * Catch-all 404 used by TanStack Router's `notFoundComponent`. Previously
 * unknown SPA routes (e.g. typos like `/speakers`, `/admin`) served a bare
 * `<div>Not Found</div>` body with no shell, no branding, no escape route
 * — the 2026-05-14 audit flagged this. This component keeps customers
 * inside the app's chrome and offers a single way back home.
 */
export function NotFound(): React.JSX.Element {
  return (
    <Center mih="100dvh" px="md">
      <Stack align="center" gap="lg" maw={420} ta="center">
        <Logo size={48} />
        <Stack gap="xs">
          <Title order={1} size="h2">
            <Trans>Page not found</Trans>
          </Title>
          <Text c="dimmed">
            <Trans>We couldn&rsquo;t find the page you were looking for. It may have moved or been removed.</Trans>
          </Text>
        </Stack>
        <Button component={Link} to="/" variant="filled" size="md">
          <Trans>Back to meetings</Trans>
        </Button>
      </Stack>
    </Center>
  )
}
